import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../hybrid/wrappers';
import Display from '../../../../common/components/Display';
import UserContext, { UserProfileContext } from '../../../../common/utils/getContext';
import { getMemoizedData } from '../../../../common/utils/memo';
import css from './Login.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import { generateUniqueId } from '../../../../common/utils/utils';
import LoginOffice from '../LoginOffice/Login';
import ModalInfoOffice from '../../../userModalInfoOffice/ModalInfoOffice';

const Login = (props) => {
    const { getHandlers = () => {}, val, gridStyles, name, align } = props;
    const { officePage } = useContext(UserProfileContext);

    const { stylers, existCl, existSt } = generateGridStyles(gridStyles, name);
    const { userToken, lang } = useContext(UserContext);

    const [sideBar, setSideBar] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const getUserData = async (val) => {
        if (val?.not_user || val?.is_deleted) return;
        if (val?.links?.partner || val?.id) {
            setSideBar(true);
        }

        const data = val?.links?.partner
            ? await getMemoizedData(val?.links?.partner, userToken, lang)
            : val?.id &&
              (await getMemoizedData(`/api/v1/user/partners/${val?.id}`, userToken, lang, false, { 'descendants-count': '1' }));
        if (!data?.data) return;
        const rankData = await getMemoizedData(data.data.marketing_profile.links.rank_progress, userToken, lang);
        if (data && data?.data) {
            const rankDataSponsor = await getMemoizedData(
                data?.data?.sponsor?.marketing_profile?.links?.rank_progress,
                userToken,
                lang
            );
            setUserInfo({
                ...data.data.profile,
                ...data.data,
                sponsor: data?.data?.sponsor
                    ? {
                          ...data.data?.sponsor,
                          package: data.data?.sponsor?.marketing_profile?.package,
                          activity: data.data?.sponsor?.marketing_profile?.activity,
                          rank: rankDataSponsor?.data?.current_rank,
                          rankData: rankDataSponsor.data
                      }
                    : null,
                activity: data.data?.marketing_profile?.activity,
                rankData: rankData.data,
                rank: rankData?.data?.current_rank,
                package: data?.data?.marketing_profile?.package,
                new_partners_number: data?.data?.marketing_profile?.new_partners_number,
                active_partners_number: data?.data?.marketing_profile?.active_partners_number,
                children_number: data?.data?.children_count,
                partners_number: data?.data?.descendants_count
            });
        }
    };
    const cursor = useMemo(
        () => (val?.not_user || (!val?.links?.partner && !val?.id) ? { cursor: 'default' } : { cursor: 'pointer' }),
        [val]
    );
    // для офісних сторінок інший логін буде (модальне вікно інакше)
    if (officePage) return <LoginOffice {...props} />;
    if (!val || (typeof val === 'object' && !val.username && !val.not_user)) {
        return <p>-</p>;
    }

    return (
        <>
            {val?.format == 'simple' ? (
                <div
                    style={existSt('wrapper') || cursor}
                    className={classnames(
                        existCl('wrapper') ||
                            (align === 'left'
                                ? [css.flexRow, css.alignItemsCenter]
                                : align === 'right'
                                ? [css.flexRow, css.alignItemsEnd]
                                : [css.flexRow, css.alignItemsCenter])
                    )}
                    onClick={() => getUserData(val)}
                >
                    <div className={css.buyerNameWrapper}>
                        <div key={generateUniqueId()}>
                            <p>
                                <b>{val?.username}</b>
                            </p>
                            <p>{val?.name}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    style={existSt('wrapper') || cursor}
                    className={classnames(
                        existCl('wrapper') ||
                            (align === 'left'
                                ? [css.flexColumn, css.alignItemsStart]
                                : align === 'right'
                                ? [css.flexColumn, css.alignItemsEnd]
                                : [css.flexColumn, css.alignItemsCenter])
                    )}
                    onClick={() => getUserData(val)}
                >
                    <p key={generateUniqueId()} style={stylers.fio} className={existCl('fio') || css.buyerName}>
                        {val.not_user ? (
                            val.not_user
                        ) : val.full_name ? (
                            val.full_name
                        ) : (
                            <Display
                                type='fio'
                                data={{
                                    first_name: val.first_name,
                                    last_name: val.last_name,
                                    patronymic: val.patronymic
                                }}
                            />
                        )}
                    </p>
                    {!val.not_user ? (
                        <div
                            {...getHandlers(false)}
                            style={stylers.icoWrap1}
                            className={
                                existCl('icoWrap1') ||
                                classnames(
                                    css.userNameBlock,
                                    !!val?.links?.partner && css.formCursorPointer,
                                    val.full_name || (val.first_name && val.last_name && val.patronymic)
                                        ? css.userNameBlockMb
                                        : ''
                                )
                            }
                        >
                            <span
                                style={stylers.icoWrap2}
                                className={
                                    existCl('icoWrap2')
                                        ? classnames(css.dFlex, css.alignItemsCenter, existCl('icoWrap2'))
                                        : classnames(css.marginRight8, css.dFlex, css.alignItemsCenter)
                                }
                            >
                                {svgSprite('user-circle-fill', {
                                    style: existSt('ico') || {
                                        fill: 'var(--blueColor)'
                                    },
                                    className: existCl('ico') || css.userNameBlockIcon
                                })}
                            </span>
                            <p style={{ whiteSpace: 'nowrap' }}>{`${val.username || val}`}</p>
                        </div>
                    ) : null}
                </div>
            )}

            {sideBar ? (
                <ModalInfoOffice
                    userData={userInfo}
                    setShowUser={setSideBar}
                    setUserData={setUserInfo}
                    closeHandler={() => {
                        setSideBar(false);
                        setUserInfo(null);
                    }}
                />
            ) : null}
        </>
    );
};
Login.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Login;
